export const getPageProgram = () => {
  const programEl = document.querySelector('div[data-program]');
  return programEl ? programEl.getAttribute('data-program') : 'academy';
};
